import { Facilities } from "../components/Facilities";
import { FadeIn } from "../components/FadeIn";
import { BOOKING_URL } from "../data/content";

export const FacilitiesPage = () => {
  return (
    <div className="py-12 sm:py-20 px-4 sm:px-8 lg:px-12">
      {/* Banner */}
      <div className="max-w-7xl mx-auto text-center mb-16">
        <FadeIn>
          <div className="text-xs uppercase tracking-[0.25em] text-emerald-400 font-extrabold mb-3">
            World-Class Infrastructure
          </div>
          <h1 className="text-4xl sm:text-6xl font-serif font-black text-transparent bg-clip-text bg-gradient-to-r from-amber-300 via-yellow-500 to-emerald-400 mb-6">
            Hammam Rajouri Garden Facilities
          </h1>
          <p className="text-white/70 max-w-2xl mx-auto text-sm sm:text-base leading-relaxed">
            Step into New Delhi's finest wellness facilities featuring hydrotherapy jacuzzis, heated eucalyptus steam rooms, sensory dark lounges, and private rainfall showers.
          </p>
        </FadeIn>
      </div>

      <Facilities />

      <div className="max-w-4xl mx-auto mt-16 p-8 rounded-3xl bg-gradient-to-r from-amber-950/30 via-black to-emerald-950/30 border border-amber-400/40 text-center">
        <FadeIn>
          <h3 className="text-2xl font-serif font-bold text-amber-300 mb-3">
            Complimentary Access With 90 Min Packages
          </h3>
          <p className="text-xs sm:text-sm text-white/70 max-w-xl mx-auto mb-6">
            All 90-minute spa packages (Service Yellow & Service Rainbow) include full access to Steam, Sauna, Jacuzzi, Dark Room & Lounge Bar.
          </p>
          <a
            href={BOOKING_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-gradient-to-r from-amber-300 to-amber-600 text-black font-extrabold px-8 py-3 rounded-full text-xs uppercase tracking-[0.15em] shadow-lg shadow-yellow-950/40 hover:scale-105 transition-transform"
          >
            Experience Facility Access
          </a>
        </FadeIn>
      </div>
    </div>
  );
};
